import Phaser from 'phaser';
import { GALAXY_1 } from '../galaxy/galaxies';
import { ProgressData as PlayerData } from '../systems/ProgressData';
import { GAME_MODE, getGameMode } from '../systems/GameMode';
import { formatScore } from '../util/numberFormat';
import { mountMenu, element, button, header, modeBadge, go } from '../util/menuUI';
import { getAvatarOption } from '../avatar/AvatarCatalog';

export class GalaxyScene extends Phaser.Scene {
  constructor() { super('GalaxyScene'); }

  create() {
    const root = mountMenu(this, 'tmag-galaxy-hub');
    const planets = GALAXY_1.planets;
    const isPractice = getGameMode(this.registry) === GAME_MODE.PRACTICE;
    header(root, 'GALAXIA DE LAS OPERACIONES ARITMÉTICAS', isPractice ? 'Elige un sistema estelar para practicar' : 'Elige un sistema estelar para explorar', '← MENÚ', () => go(this, 'MenuScene'));

    if (!isPractice) {
      const done = planets.filter(p => PlayerData.isPlanetComplete(p.id)).length;
      root.append(element('p', 'tmag-galaxy-progress', `Progreso: ${done} / ${planets.length} sistemas`));
    }

    const profile = PlayerData.getProfile();
    const isExploradora = profile.explorer === 'exploradora';
    const guide = element('img', 'tmag-galaxy-guide');
    guide.src = getAvatarOption('bases', isExploradora ? 'exploradora' : 'explorador').portraitAsset;
    guide.alt = isExploradora ? 'Astronauta exploradora guía' : 'Astronauta explorador guía';
    const head = root.querySelector('.tmag-menu-header');
    const toolbar = element('div', 'tmag-galaxy-toolbar');
    const student = this.registry.get('studentIdentity');
    const profileButton = student
      ? element('span', 'tmag-button tmag-profile-chip', `✦ ${student.alias}`)
      : button(`✦ ${profile.nickname || 'MI PERFIL'}`, () => {
        if (this.menuLeaving) return;
        this.menuLeaving = true;
        this.scene.start('ProfileScene', { source: 'galaxy' });
      }, 'tmag-button tmag-profile-chip');
    toolbar.append(head.querySelector('.tmag-back'), profileButton, modeBadge(this), guide);
    head.prepend(toolbar);

    const grid = element('div', 'tmag-portal-grid');
    const missionMap = { suma: 'SumaMissionsScene', resta: 'RestaMissionsScene', mult: 'MultiplicacionMissionsScene', division: 'DivisionMissionsScene' };

    planets.forEach(p => {
      const complete = !isPractice && PlayerData.isPlanetComplete(p.id);
      const accessible = isPractice || p.unlocked;
      const card = button('', () => go(this, missionMap[p.id] || 'MissionScene', () => {
        this.registry.set('currentPlanet', p.id);
        this.registry.get('audio')?.playCollect();
      }), `tmag-portal tmag-portal-${p.id}${complete ? ' tmag-portal-complete' : ''}`);
      card.disabled = !accessible;
      // Acento exclusivo del portal de Suma en esta pantalla compartida.
      // No altera la identidad de Suma en misiones ni durante el juego.
      const portalAccent = p.id === 'suma' ? '#38F0E0' : p.css;
      card.style.setProperty('--planet-color', portalAccent);

      const ring = element('span', 'tmag-portal-ring');
      ring.append(element('span', 'tmag-portal-window'));
      ring.append(element('span', 'tmag-portal-symbol', p.symbol));
      if (!isPractice && !p.unlocked) ring.append(element('span', 'tmag-portal-lock', '🔒'));

      card.append(ring, element('h2', '', p.name.toUpperCase()));
      if (!isPractice) {
        card.append(element('span', 'tmag-status',
          !p.unlocked ? 'PRÓXIMAMENTE' : complete ? '✓ COMPLETADO' : '▶ DISPONIBLE'));
        const best = PlayerData.getPlanetBest(p.id);
        card.append(element('span', 'tmag-card-info', best ? `★ ${formatScore(best)} pts` : '★ Mejor: —'));
      }
      grid.append(card);
    });
    root.append(grid);
  }
}
